module.exports = __webpack_public_path__ + "static/img/3.8bd998f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/eng/3.png
// module id = NoH4
// module chunks = 0